/**
 * AlertBanner
 *
 * Banner persistente no topo da aba Canais (ou onde quiser exibir).
 * Mostra apenas alertas BANNER_EVENTS não-lidos (geralmente severity=error
 * que requerem ação).
 *
 * Click no CTA → emite evento via callback para o parent navegar.
 */

import React from 'react';
import { IconX } from '@tabler/icons-react';
import { useChannelAlerts } from '../../contexts/ChannelAlertsContext';
import {
  SEVERITY_THEME,
  BANNER_EVENTS,
  EVENT_ICONS,
  effectiveSeverity,
  resolveAlertCTA,
} from './alertConfig';

const AlertBanner = ({ onCTA, filters = {} }) => {
  const { alerts, markRead } = useChannelAlerts(filters);

  // Mostra apenas o mais recente alerta de banner não-lido
  const visibleAlert = alerts.find(
    (a) => !a.read && BANNER_EVENTS.has(a.event),
  );

  if (!visibleAlert) return null;

  const severity = effectiveSeverity(visibleAlert);
  const theme = SEVERITY_THEME[severity] || SEVERITY_THEME.info;
  const Icon = EVENT_ICONS[visibleAlert.event];
  const cta = resolveAlertCTA(visibleAlert);

  return (
    <div
      role="alert"
      style={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 12,
        padding: '12px 16px',
        marginBottom: 16,
        background: theme.bg,
        border: `1px solid ${theme.border}`,
        borderRadius: 8,
        color: theme.color,
      }}
    >
      {Icon && (
        <Icon size={20} style={{ color: theme.iconColor, flexShrink: 0, marginTop: 2 }} />
      )}
      <div style={{ flex: 1, fontSize: 14, lineHeight: 1.5 }}>
        <strong style={{ display: 'block', marginBottom: 4 }}>
          {theme.label}
        </strong>
        {visibleAlert.message}
      </div>
      <div style={{ display: 'flex', gap: 8, flexShrink: 0 }}>
        {cta && (
          <button
            type="button"
            onClick={() => {
              markRead(visibleAlert.id);
              if (onCTA) onCTA(cta.action, visibleAlert);
            }}
            style={{
              padding: '6px 12px',
              border: `1px solid ${theme.iconColor}`,
              background: theme.iconColor,
              color: '#fff',
              borderRadius: 6,
              fontSize: 13,
              fontWeight: 600,
              cursor: 'pointer',
              whiteSpace: 'nowrap',
            }}
          >
            {cta.label}
          </button>
        )}
        <button
          type="button"
          onClick={() => markRead(visibleAlert.id)}
          aria-label="Fechar alerta"
          title="Marcar como lido"
          style={{
            padding: 6,
            border: 'none',
            background: 'transparent',
            color: theme.color,
            cursor: 'pointer',
          }}
        >
          <IconX size={16} />
        </button>
      </div>
    </div>
  );
};

export default AlertBanner;
